/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { ShipmentTimelineEvent } from './shipment-timeline-events.models';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Shipment } from '@qwyk/shared-stores/shipments';

export const init = createAction(
    '[Portals/Shipments/TimelineEvents] Init',
    props<{ shipment: Shipment }>()
);

export const loadShipmentTimelineEventsSuccess = createAction(
    '[Portals/Shipments/TimelineEvents] Load ShipmentTimelineEvents Success',
    props<{ shipmentTimelineEvents: ShipmentTimelineEvent[] }>()
);

export const loadShipmentTimelineEventsFailure = createAction(
    '[Portals/Shipments/TimelineEvents] Load ShipmentTimelineEvents Failure',
    props<{ error: any }>()
);

export const updateShipmentTimelineEvent = createAction(
    '[Portals/Shipments/TimelineEvents] Update ShipmentTimelineEvent',
    props<{
        shipment: Shipment;
        shipmentTimelineEvent: ShipmentTimelineEvent;
        changes: Partial<ShipmentTimelineEvent>;
    }>()
);

export const updateShipmentTimelineEventSuccess = createAction(
    '[Portals/Shipments/TimelineEvents] Update ShipmentTimelineEvent Success',
    props<{ shipmentTimelineEvent: ShipmentTimelineEvent }>()
);

export const confirmShipmentTimelineEvent = createAction(
    '[Portals/Shipments/TimelineEvents] Confirm ShipmentTimelineEvent',
    props<{
        shipment: Shipment;
        shipmentTimelineEvent: ShipmentTimelineEvent;
        changes: Partial<ShipmentTimelineEvent>;
    }>()
);

export const confirmShipmentTimelineEventSuccess = createAction(
    '[Portals/Shipments/TimelineEvents] Confirm ShipmentTimelineEventSuccess',
    props<{
        shipmentTimelineEvent: ShipmentTimelineEvent;
        shipmentId: string;
    }>()
);

export const updateShipmentTimelineEventFailure = createAction(
    '[Portals/Shipments/TimelineEvents] Update ShipmentTimelineEvent Failure',
    props<{ error: any }>()
);

export const confirmShipmentTimelineEventFailure = createAction(
    '[Portals/Shipments/TimelineEvents] Confirm ShipmentTimelineEvent Failure',
    props<{ error: any }>()
);

export const createShipmentTimelineEvent = createAction(
    '[Portals/Shipments/TimelineEvents] Create ShipmentTimelineEvent',
    props<{
        shipment: Shipment;
        payload: any;
    }>()
);

export const createShipmentTimelineEventSuccess = createAction(
    '[Portals/Shipments/TimelineEvents] Create ShipmentTimelineEvent Success',
    props<{
        shipmentTimelineEvent: ShipmentTimelineEvent;
        shipmentId: string;
    }>()
);

export const createShipmentTimelineEventFailure = createAction(
    '[Portals/Shipments/TimelineEvents] Create ShipmentTimelineEvent Failure',
    props<{ error: any }>()
);

export const selectShipmentTimelineEvent = createAction(
    '[Portals/Shipments/TimelineEvents] Select ShipmentTimelineEvent',
    props<{ selectedId: string }>()
);

export const unselectShipmentTimelineEvent = createAction(
    '[Portals/Shipments/TimelineEvents] Unselect ShipmentTimelineEvent'
);

export const reset = createAction('[Portals/Shipments/TimelineEvents] Reset');

export const dismissError = createAction(
    '[Portals/Shipments/TimelineEvents] Dismiss Error'
);
